import { tokens } from "../../../theme";
import { Box, IconButton, Tooltip, Typography, useTheme } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import { getHeaders } from "../../../utils/apiclient";
import { useHasPermissionState } from "../../../api/iam";
import { releaseStyles } from "../styles";

const ArchivedReleasePill = ({ release, app, showReleaseStatusDialog }) => {
  const theme = useTheme();
  const { summaryTable } = releaseStyles(tokens(theme.paletteId));

  const deletableByStatus = (release?.actionsAllowed || []).includes("DELETE");
  const { hasPermission, isLoading } = useHasPermissionState(
    `/apps/${app}/releases/${release?.name}`,
    "PATCH",
    "DELETE"
  );
  const canDelete = deletableByStatus && hasPermission;
  // Show the control as soon as the release's own status allows deletion;
  // it stays disabled until we know whether the user is permitted too.
  const showDeleteControl = deletableByStatus && (isLoading || canDelete);

  const deleteRelease = () =>
    showReleaseStatusDialog(
      `Perform action DELETE on release ${release?.name}`,
      `/${release?.name}`,
      { headers: { ...getHeaders(), Action: "DELETE" } }
    );

  return (
    <Box sx={summaryTable.archivedPill(canDelete)}>
      <Typography component="span" sx={summaryTable.archivedPillName}>
        {release?.name}
      </Typography>
      {showDeleteControl ? (
        <Tooltip
          title={
            <Typography>
              {isLoading ? "Checking permissions…" : `Delete ${release?.name}`}
            </Typography>
          }
        >
          <span>
            <IconButton
              size="small"
              aria-label={`Delete ${release?.name}`}
              sx={summaryTable.archivedDelete}
              disabled={isLoading}
              onClick={deleteRelease}
            >
              <DeleteOutline sx={{ fontSize: 15 }} />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
    </Box>
  );
};

const ArchivedReleases = ({ releases = [], app, showReleaseStatusDialog }) => {
  const theme = useTheme();
  const { summaryTable } = releaseStyles(tokens(theme.paletteId));
  return (
    <Box sx={summaryTable.archivedRow}>
      <Typography
        sx={summaryTable.archivedCount}
      >{`${releases.length} archived`}</Typography>
      <Box sx={summaryTable.archivedList}>
        {releases.map((release) => (
          <ArchivedReleasePill
            key={release?.name}
            release={release}
            app={app}
            showReleaseStatusDialog={showReleaseStatusDialog}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ArchivedReleases;
